import { zodResolver } from "@hookform/resolvers/zod"
import type { FieldValues, Resolver } from "react-hook-form"
import type { z } from "zod"

/**
 * Forms start with empty placeholders (a `null` pickup or category) that the
 * schema rejects on submit, so their field values are looser than the
 * schema's input type. `@hookform/resolvers` 5 types `zodResolver` from the
 * schema; this keeps the form's own value type, as resolvers 3 did.
 */
export function zodFormResolver<TFieldValues extends FieldValues>(
  schema: z.ZodType<FieldValues, FieldValues>,
): Resolver<TFieldValues> {
  return (zodResolver(schema) as unknown) as Resolver<TFieldValues>
}
